// Shared formatting. A share is never shown without what it rests on.
export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 1) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const money = (v) => (v == null ? '—' : `₹${Number(v).toLocaleString('en-IN')}`);

// The PRD's four components, and what each is actually measuring.
export const COMPONENT_LABEL = {
  reach: 'Reach', attention: 'Attention', breadth: 'Breadth', traffic: 'Traffic',
};
export const COMPONENT_MEANING = {
  reach: 'how much of the demand on its terms it captures',
  attention: 'whether it earns clicks when shown, against the market',
  breadth: 'visibility spread across terms rather than resting on one',
  traffic: 'session change against the previous window',
};
export const VERDICT_CLASS = {
  Strong: 'strong', Healthy: 'healthy', Patchy: 'patchy', Weak: 'weak',
};
